import adminHttp from "/src/api/adminHttp";

const END_POINT = '/api/admin/format';

export default {
    /**
     * GET: Games
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    index: (params = {}) => adminHttp.get(END_POINT, {params:params}),
}